import React from "react";

const FormNav = ({tab, setTab}) => {
    return (
        <div className="wizard-nav">
            <div className="wizard-steps justify-content-start">
                {/* <!--begin::Wizard Step 1 Nav--> */}
                <div
                    className="wizard-step mr-sm-2"
                    data-wizard-type="step"
                    data-wizard-state={tab === 1 ? "current" : ""}
                    onClick={_ => setTab(1)}
                >
                    <div className="wizard-wrapper">
                        <div className="wizard-number">1</div>
                        <div className="wizard-label">
                            <div className="wizard-title">Exchange rate details</div>
                            <div className="wizard-desc">Basic Information</div>
                        </div>
                    </div>
                </div>
                {/* <!--end::Wizard Step 1 Nav--> */}
                {/* <!--begin::Wizard Step 2 Nav--> */}
                <div
                    className="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state={tab === 2 ? "current" : ""}
                    onClick={_ => setTab(2)}
                >
                    <div className="wizard-wrapper">
                        <div className="wizard-number">2</div>
                        <div className="wizard-label">
                            <div className="wizard-title">Completed</div>
                            <div className="wizard-desc">Review and Submit</div>
                        </div>
                    </div>
                </div>
                {/* <!--end::Wizard Step 2 Nav--> */}
            </div>
        </div>
    )
}

export default FormNav;